import { __assign } from "tslib";
import React from 'react';
import DeviationDumbView from '../../DeviationViews/Dumbo';
import SubfoldersIcon from '@wix/da-ds/pkg/Icons/24x24/Subfolders';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import folderSropdownDesktopStyles from './FolderDropdownDesktop.scss';
var FolderThumb = function (_a) {
    var folder = _a.folder, hasSubfolders = _a.hasSubfolders;
    var deviation = folder.thumb;
    if (!deviation) {
        return null;
    }
    var previewProps = {
        deviation: deviation,
        width: 114,
        height: 64,
    };
    return (React.createElement("div", { className: folderSropdownDesktopStyles['thumb-wrapper'] },
        React.createElement(DeviationDumbView, __assign({}, previewProps, { className: folderSropdownDesktopStyles['thumb'] })),
        hasSubfolders && (React.createElement(SubfoldersIcon, { size: IconSize.SMALL, className: folderSropdownDesktopStyles['subfolders-icon'] }))));
};
FolderThumb.displayName = 'FolderThumb';
export default FolderThumb;
//# sourceMappingURL=FolderThumb.js.map